'use client';

import { useTranslations } from 'next-intl';
import { FAQ, type FAQItem } from '@/app/components/ui/FAQ';
import { Link } from '@/i18n/routing';

export function QuestionSection() {
  const t = useTranslations('ai-reference-to-video');

  // 动态创建 FAQ 问题数据
  const faqItems: FAQItem[] = (['q1', 'q2', 'q3', 'q4', 'q5'] as const).map((key, index) => {
    const description = t(`faq.${key}.description`);

    // 为 q2 添加 Image to Video 链接
    if (key === 'q2') {
      return {
        id: `faq-${index + 1}`,
        question: t(`faq.${key}.title`),
        answer: [
          {
            title: `${description} `,
            link: (
              <Link href="/ai-image-to-video" className="text-[#0086FF] hover:underline">
                Try Image to Video
              </Link>
            ),
          },
        ],
      };
    }

    // 为 q5 添加 Text to Video 链接
    if (key === 'q5') {
      return {
        id: `faq-${index + 1}`,
        question: t(`faq.${key}.title`),
        answer: [
          {
            title: `${description} `,
            link: (
              <Link href="/ai-text-to-video" className="text-[#0086FF] hover:underline">
                Generate videos from text prompts
              </Link>
            ),
          },
        ],
      };
    }

    return {
      id: `faq-${index + 1}`,
      question: t(`faq.${key}.title`),
      answer: [{ title: description }],
    };
  });

  return (
    <section className="bg-black">
      <div className="mx-auto">
        <FAQ items={faqItems} title={t('faq.title')} customTopMargin="mt-20" customBottomMargin="mb-20" />
      </div>
    </section>
  );
}
